import React, { useEffect, useState } from "react";
import useMediaQuery from "../../hooks/use-media-query";
import { useParams } from "react-router-dom";
import Axios from "axios";
import Styles from "./project.module.css";
import parse from "html-react-parser";
import { Space, Table, Tag, Button } from "antd";
import { PlayCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";

const KitPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(991);
  const [kit, setKit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [projectsLoading, setProjectsLoading] = useState(true);

  useEffect(() => {
    Axios.get(`https://ap.roboarmy.in/api/kit/${id}`)
      .then((res) => {
        setKit(res.data.payload[0]);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    const fetchProjects = async () => {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: "https://ap.roboarmy.in/api/project/",
        headers: {},
      };

      Axios.request(config)
        .then((response) => {
          // Filter projects where item.primary_kit.id == id
          const filtered = response.data.payload.filter(
            (item) =>
              item.primary_kit && String(item.primary_kit.id) === String(id)
          );
          setProjects(filtered);
          setProjectsLoading(false);
        })
        .catch(() => setProjectsLoading(false));
    };
    fetchProjects();
  }, [id]);

  if (loading) return <div>Loading kit details...</div>;
  if (!kit) return <div>Kit not found.</div>;

  return (
    <div style={{ padding: 32, margin: "0 auto" }}>
      <h2>{kit.kit_name}</h2>
      {/* List related projects */}
      <div style={{ marginTop: 40 }}>
        {projectsLoading ? (
          <div>Loading projects...</div>
        ) : projects.length === 0 ? (
          <div>No projects found for this kit.</div>
        ) : (
          <div>
            {projects.map((item) => {
              return (
                <div
                  className={Styles.card}
                  style={{ display: isMobile ? "block" : "" }}
                >
                  <img
                    src={`https://roboarmythumbnail.s3.ap-south-1.amazonaws.com/project/${item.id}.png`}
                    alt="Logo"
                    style={{
                      width: isMobile ? "100%" : 350,
                      height: isMobile ? "70%" : 200,
                      borderRadius: 16,
                    }}
                  />
                  <div className={Styles.cardHeading}>
                    {`${item.project_name}`}
                    <p style={{ fontWeight: "normal", paddingTop: 20 }}>
                      {parse(item.description)}
                    </p>
                    <Button
                      type="primary"
                      shape="round"
                      icon={<PlayCircleOutlined />}
                      size={"large"}
                      onClick={() => {
                        navigate(`/project/${item.id}`);
                      }}
                    >
                      Watch now
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default KitPage;
